import { useSuspenseQuery } from '@tanstack/react-query'

import { fetchAppSettings } from '../settings/fetchAppSettings'
import { appSettings } from '../settings/keys'

export const useFetchAppSettings = () =>
  useSuspenseQuery({
    queryKey: appSettings,
    queryFn: fetchAppSettings,
    staleTime: 'static',
  })
